<template>
  <div class="vc-home vc-ai-flex-start">
    <div class="history white--text text-center">
      <h1>Histórico de fichas</h1>
      <h5 class="text-center" v-if="reports.length > 0">De {{ formatDisplayDate(startDate) }} até {{ formatDisplayDate(endDate) }}</h5>
      <v-btn
        color="primary"
        class="ma-2 mb-0 white--text"
        @click="(showModal = true)"
        :disabled="reports.length == 0" 
      >
      
        Visualizar
        <v-icon right dark>
          mdi-printer
        </v-icon>
      </v-btn>
      <div class="text-start">
        <HistoryTable :reports="reports" />
      </div>
    </div>
    <Footer />

    <v-dialog v-model="showModal" max-width="100vw">
      <v-card>
        <v-card-title class="headline">Visualizar Relatório</v-card-title>
        <v-card-text class="modal-content">
          <VueHtml2pdf
            ref="html2pdf"
            :show-layout="false"
            :float-layout="false"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="paginationHeight"
            :manual-pagination="true"
            :pdf-format="'a4'"
            :pdf-orientation="htmlToPdfOptions.jsPDF.orientation"
            :pdf-content-width="2400"
            :html2canvas-options="htmlToPdfOptions.html2canvas"
            :js-pdf-options="htmlToPdfOptions.jsPDF"
            :html-to-pdf-options="htmlToPdfOptions"
            @progress="handleProgress"
            @error="handleError"
            @beforeDownload="beforeDownload($event)"
            :page-break="htmlToPdfOptions.pagebreak"
          >
            <section class="historyComponent" slot="pdf-content">
              <HtmlHistoryTable
                :reports="reports"
                :startDate="startDate"
                :endDate="endDate"
              />
            </section>
          </VueHtml2pdf>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="generatePdf">Imprimir Relatório</v-btn>
          <v-btn color="secondary" @click="showModal = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { format, parseISO, isValid } from "date-fns";
import Footer from "@/components/HomeComponents/Footer.vue";
import HistoryTable from "@/components/HistoryComponents/HistoryTable.vue";
import HtmlHistoryTable from "@/components/HistoryComponents/HtmlHistoryTable.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "history-report",
  components: {
    HistoryTable,
    Footer,
    HtmlHistoryTable,
    VueHtml2pdf,
  },
  props: {
    reports: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      showModal: false,
      paginationHeight: 1200,
      htmlToPdfOptions: {
        margin: [10, 4, 10, 20],
        image: { type: "jpeg", quality: 2 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          scale: 2,
          dpi: 300,
          x: -50,
        },
        jsPDF: {
          orientation: "l",
        },
        pagebreak: { mode: "avoid-all" },
        filename: "Relatório de fichas.pdf",
      },
    };
  },
  methods: {
    formatDisplayDate(dateString) {
      if (!dateString) return "";
      const date = parseISO(dateString);
      if (!isValid(date)) return "-";
      return format(date, "dd/MM/yyyy");
    },
    generatePdf() {
      console.log(this.reports);
      this.$refs.html2pdf.generatePdf();
    },
    handleProgress(progressData) {
      console.log(progressData);
    },
    handleError(errorData) {
      console.error(errorData);
    },
  },
};
</script>

<style scoped>
.vc-home {
  max-height: 100vh;
  overflow: hidden;
  position: relative;
}

.modal-content {
  max-height: 70vh;
  overflow-y: auto;
}

.v-card-actions {
  justify-content: flex-end;
}

.v-dialog__content {
  z-index: 1050 !important;
}
.historyComponent {
  overflow-x: hidden;
}
</style>
